export const ProductAction = {
    GET_LIST: "get_list",
    UPDATE_SEARCH_TEXT: "update_search_text",
    GET_PRODUCT_INFO: "get_product_info",
    UPDATE_FILTER_COMPANY: "update__filter_company",
    UPDATE_AVAILABILITY: "update_availability",
    INIT_SEARCH_DTO_AND_PRODUCT_LIST: "init_search_dto_and_product_list",
    REMOVE_FILTER_COMPANY: "remove_filter_company"
}